module.exports = __webpack_public_path__ + "img/fr4.a0913983.png";